var map = {
	"./customer-bg.webp": 1477,
	"./customer-img.webp": 1478,
	"./dice-img.webp": 1479,
	"./games-img.webp": 1480,
	"./lc-img.webp": 1481,
	"./lottery-img.webp": 1482,
	"./mission-bg.webp": 1483,
	"./mission-img-2.webp": 1484,
	"./mission-img.webp": 1485,
	"./mission-main-bg.webp": 1486,
	"./mobile-bg.webp": 1487,
	"./p2p-img.webp": 1488,
	"./product-bg.webp": 1489,
	"./product-main-bg.webp": 1490,
	"./sb-provider.webp": 1491,
	"./sbo-provider.webp": 1492,
	"./side-bar-bg.webp": 1493,
	"./slot-img.webp": 1494,
	"./spade-img.webp": 1495,
	"./sport-img.webp": 1496
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 208;